"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bytes_1 = __importDefault(require("bytes"));
class MicriError extends Error {
    constructor(statusCode, code, message, originalError) {
        super(message);
        this.statusCode = statusCode;
        this.code = code;
        this.originalError = originalError || null;
    }
}
exports.MicriError = MicriError;
class MicriBodyError extends MicriError {
    constructor(err, limit) {
        let statusCode = 400;
        let code = 'invalid_body';
        let message = 'Invalid body';
        if (err.type === 'entity.too.large') {
            statusCode = 413;
            code = 'request_entity_too_large';
            message = `Body exceeded ${typeof limit === 'string' ? limit : bytes_1.default(limit)} limit`;
        }
        super(statusCode, code, message, err);
    }
}
exports.MicriBodyError = MicriBodyError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2hicC9yZXBvcy9taWNyaS9zcmMvZXJyb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQ0Esa0RBQTBCO0FBRzFCLE1BQWEsVUFBVyxTQUFRLEtBQUs7SUFLcEMsWUFBWSxVQUFrQixFQUFFLElBQVksRUFBRSxPQUFlLEVBQUUsYUFBcUI7UUFDbkYsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBRWYsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7UUFDN0IsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxDQUFDLGFBQWEsR0FBRyxhQUFhLElBQUksSUFBSSxDQUFDO0lBQzVDLENBQUM7Q0FDRDtBQVpELGdDQVlDO0FBRUQsTUFBYSxjQUFlLFNBQVEsVUFBVTtJQUM3QyxZQUFZLEdBQWlCLEVBQUUsS0FBc0I7UUFDcEQsSUFBSSxVQUFVLEdBQUcsR0FBRyxDQUFDO1FBQ3JCLElBQUksSUFBSSxHQUFHLGNBQWMsQ0FBQztRQUMxQixJQUFJLE9BQU8sR0FBRyxjQUFjLENBQUM7UUFFN0IsSUFBSSxHQUFHLENBQUMsSUFBSSxLQUFLLGtCQUFrQixFQUFFO1lBQ3BDLFVBQVUsR0FBRyxHQUFHLENBQUM7WUFDakIsSUFBSSxHQUFHLDBCQUEwQixDQUFDO1lBQ2xDLE9BQU8sR0FBRyxpQkFBaUIsT0FBTyxLQUFLLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLGVBQUssQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDO1NBQ3BGO1FBRUQsS0FBSyxDQUFDLFVBQVUsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7Q0FDRDtBQWRELHdDQWNDIn0=